module.exports = __webpack_public_path__ + "img/arrow-down.a6625c88.svg";